import React, { memo, useCallback } from 'react';

import { Box, IconButton, Typography } from '@mui/material';
import { CancelIcon, ReplyIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { TEAM_CHAT_FALLBACK_MEMBER_NAME } from '../TeamChat.constants';
import {
  getMemberNickname,
  getMessageId,
  getMessageSender,
  getMessageText,
  scrollToTeamChatMessage,
} from '../TeamChat.utils';

import { rootStyles } from './TeamChatReplyPreview.styles';
import { TeamChatReplyPreviewTestIds } from './TeamChatReplyPreview.testIds';
import { buildReplyPreview } from './TeamChatReplyPreview.utils';

const TeamChatReplyPreview = memo(({ parent = null, members = null, onCancel = null }) => {
  const parentId = parent ? getMessageId(parent) : null;
  const sender = parent ? getMessageSender(parent, members) : null;
  const nickname = sender
    ? getMemberNickname(sender) || sender.nickname || TEAM_CHAT_FALLBACK_MEMBER_NAME
    : '';

  const onClick = useCallback(() => {
    scrollToTeamChatMessage(parentId);
  }, [parentId]);

  const onCancelClick = useCallback(
    e => {
      e.stopPropagation();
      onCancel?.();
    },
    [onCancel],
  );

  return (
    !!parent && (
      <Box sx={rootStyles} onClick={onClick}>
        <ReplyIcon size={IconSize[14]} />
        <Typography variant="medium12">{nickname}:</Typography>
        <Typography variant="regular12">{buildReplyPreview(getMessageText(parent))}</Typography>
        {!!onCancel && (
          <IconButton
            aria-label="Cancel reply"
            data-testid={TeamChatReplyPreviewTestIds.CANCEL_BUTTON}
            size="small"
            onClick={onCancelClick}
          >
            <CancelIcon size={IconSize[18]} />
          </IconButton>
        )}
      </Box>
    )
  );
});
TeamChatReplyPreview.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object),
  parent: PropTypes.object,
  onCancel: PropTypes.func,
};

export default TeamChatReplyPreview;
